export default "__VITE_ASSET__BFSpiZ_V__"